<template>
  <div class="image-container" ref="imageContainer">
    <img
      ref="image"
      src="@/assets/WhatsApp Image 2026-07-11 at 2.46.53 PM (1) (1).webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >

    <!-- OVERLAY OSCURECIDO ARRIBA Y ABAJO -->
    <div class="overlay"></div>

    <div ref="textRef" class="text-overlay">
      <p class="firma">
      Thank you for sharing this day with me!<br>
        <span>Rosalie Torres</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const imageContainer = ref(null)

    onMounted(() => {
      gsap.fromTo(
        image.value,
        { opacity: 0, scale: 1.1 },
        {
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      )

      gsap.fromTo(
        textRef.value,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.8,
          delay: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      )
    })

    return { textRef, image, imageContainer }
  }
}
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 650px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(98%);
}

/* 🔑 OVERLAY CORREGIDO (OSCURECE MÁS ABAJO) */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.45) 0%,
    rgba(0,0,0,0.2) 35%,
    rgba(0,0,0,0.4) 70%,
    rgba(0,0,0,0.75) 100%
  );
}

/* TEXTO */
.text-overlay {
  position: absolute;
  top: 535px;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
  opacity: 0;
  padding: 0 20px;
}

.firma {
  font-size: 19px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: -15px;
  font-family: "titulos", cursive;
  font-size: 2.4rem !important;
}
</style>
